import React from 'react';
import Banner from '@cpg-its/ads.containers.banner';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../../../../../global/components/wysiwyg-with-react-link';
import { PensionEnrollmentProps } from '../../../models/arc-epi-props';

interface Props {
    pensionEnrollmentProps: PensionEnrollmentProps;
}

export function PensionEnrollmentVerifyMarital(props: Props) {
    const { pensionEnrollmentProps } = props;

    return (
        <>
            <ContentSpacer>
                <Banner
                    banner={{
                        type: 'warning',
                        label: <div className='rich-text'><WysiwygWithReactLink content={pensionEnrollmentProps?.verifyMaritalStatusMessage} /></div>,
                    }}
                />
            </ContentSpacer>
            <ContentSpacer>
                <p>{pensionEnrollmentProps?.maritalStatusConfirmPrompt}</p>
            </ContentSpacer>
            <ContentSpacer>
                <p><strong>{pensionEnrollmentProps?.maritalStatusLabel}</strong></p>
                <p>{pensionEnrollmentProps?.singleText || 'Single'}</p>
            </ContentSpacer>
            <ContentSpacer>
                <p>{pensionEnrollmentProps?.maritalStatusVerifyQuestion}</p>
            </ContentSpacer>
        </>
    );
}